module.exports = __webpack_public_path__ + "static/media/08.68459f52.jpg";